import { useMemo } from "react";

export default function PerformancePanel({ data = [] }) {

  const { top, worst } = useMemo(() => {
    const sorted = [...data]
      .filter(d => d.revenue > 0)
      .sort((a, b) => b.margin - a.margin);
    return {
      top: sorted.slice(0, 3),
      worst: sorted.slice(-3).reverse()
    };
  }, [data]);

  const fmt = v =>
    Number(v || 0).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

  return (
    <div style={{
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: 12,
      margin: "20px 0"
    }}>

      {/* TOP */}
      <div style={{
        background: "#ffffff",
        border: "1px solid #e5e7eb",
        borderRadius: 10,
        padding: 16,
      }}>
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          marginBottom: 14,
        }}>
          <span style={{ fontSize: 14 }}>🔥</span>
          <span style={{
            fontSize: 11,
            fontWeight: 600,
            textTransform: "uppercase",
            letterSpacing: "0.06em",
            color: "#6b7280",
          }}>
            Top Performers
          </span>
        </div>

        {top.map(t => (
          <div key={t.name} style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "7px 0",
            borderBottom: "1px solid #f3f4f6",
          }}>
            <span style={{ fontSize: 13, color: "#111827" }}>{t.name}</span>
            <span style={{ fontSize: 13, fontWeight: 600, color: "#1D9E75" }}>{fmt(t.margin)}</span>
          </div>
        ))}
      </div>

      {/* WORST */}
      <div style={{
        background: "#ffffff",
        border: "1px solid #e5e7eb",
        borderRadius: 10,
        padding: 16,
      }}>
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          marginBottom: 14,
        }}>
          <span style={{ fontSize: 14 }}>⚠️</span>
          <span style={{
            fontSize: 11,
            fontWeight: 600,
            textTransform: "uppercase",
            letterSpacing: "0.06em",
            color: "#6b7280",
          }}>
            Needs Attention
          </span>
        </div>

        {worst.map(t => (
          <div key={t.name} style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "7px 0",
            borderBottom: "1px solid #f3f4f6",
          }}>
            <span style={{ fontSize: 13, color: "#111827" }}>{t.name}</span>
            <span style={{ fontSize: 13, fontWeight: 600, color: "#f97316" }}>{fmt(t.margin)}</span>
          </div>
        ))}
      </div>

    </div>
  );
}